// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 10"
    {...props}
  >
    <rect
      width={5.035}
      height={5.035}
      x={0.8}
      y={1.06}
      stroke="currentColor"
      strokeWidth={1.6}
      rx={1.096}
    />
    <rect
      width={5.035}
      height={5.035}
      x={15.966}
      y={1.06}
      stroke="currentColor"
      strokeWidth={1.6}
      rx={1.096}
    />
    <rect
      width={5.035}
      height={5.035}
      x={8.382}
      y={1.06}
      stroke="currentColor"
      strokeWidth={1.6}
      rx={1.096}
    />
    <rect
      width={21.326}
      height={0.474}
      x={0.237}
      y={9.029}
      stroke="currentColor"
      strokeWidth={0.474}
      rx={0.237}
    />
  </svg>
);
const IconLikert = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconLikert;
